<template>
  <div class="w-full flex p-3 justify-center">
    <div class="w-full">
      <div
        class="vx-row m-0 w-full text-left flex font-bold border-b border-gray-300"
      >
        <div class="vx-col p-2 flex-1 basis-1/12">Nº da Proposta</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Data da Proposta</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Tipo de cotação</div>
        <div class="vx-col p-2 flex-1 basis-2/12">Segurado</div>
        <div class="vx-col p-2 flex-1 basis-2/12">Veículo</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Data Limite Vistoria</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Reativar</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Vistoria</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Corretora</div>
      </div>
      <ul>
        <li v-for="item in cotacoes" :key="item.id_proposta">
          <div
            class="vx-row m-0 w-full text-left flex border-b border-gray-200"
          >
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              <a
                style="color: inherit"
                target="_blank"
                :href="getDetailsUrl(item)"
                class="cursor-pointer flex items-center justify-between w-6/12"
              >
                <div class="mr-2">
                  {{ item.proposal_number }}
                </div>
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-external-link"
                ></vs-icon>
              </a>
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{ functions.formataDataHoraPadraoBR(item.proposal_date, false) }}
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{
                isEndorsement(item)
                  ? QUOTATION_TYPE.ENDORSEMENT
                  : QUOTATION_TYPE.NEW
              }}
            </div>
            <div class="vx-col p-2 flex-1 basis-4/12 flex items-center">
              <a
                target="_blank"
                style="color: inherit"
                :href="`/DetalheSegurado/${item.id_prospect}`"
                class="font-semibold flex items-center justify-between w-11/12"
              >
                {{ item.nome }}
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-external-link"
                ></vs-icon>
              </a>
            </div>
            <div class="vx-col p-2 flex-1 basis-2/12 flex items-center">
              {{ item.placa && `${item.placa} - ` }} {{ item.veiculoModelo }}
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{
                functions.formataDataHoraPadraoBR(
                  item.validity_inspection,
                  false,
                )
              }}
            </div>
            <div
              class="vx-col p-2 flex-1 basis-1/12 flex items-center cursor-pointer"
            >
              <div
                class="mr-3 p-0 w-10 flex-1 flex items-center justify-evenly"
                :class="
                  !permitirReabrirVistoria(item)
                    ? 'disabled-button'
                    : 'cursor-pointer'
                "
                @click="reabrirVistoria(item)"
                v-tooltip="getTooltipText(item)"
              >
                <vs-icon
                  color="primary"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                >
                </vs-icon>
                <span>Reabrir Vistoria</span>
              </div>
            </div>
            <div
              class="vx-col p-2 flex-1 basis-1/12 flex items-center font-semibold"
            >
              Copiar <br />
              Link
              <div
                class="flex-1 flex items-center justify-evenly cursor-pointer"
                @click="copiarLink(item.chave)"
              >
                <vs-icon
                  color="primary"
                  icon-pack="feather"
                  icon="icon-copy"
                  class="w-full h-full icon-copy-large"
                >
                </vs-icon>
              </div>
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{ item.brokerName }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import lifeService from '../../../../services/life-api';
import notify from '../../../../utils/notify';
import functions from '../../../../utils/functions';
import { QUOTATION_TYPE } from '../../../../constants/quotation.type';

export default {
  props: {
    cotacoes: Array,
  },
  data() {
    return {
      QUOTATION_TYPE,
      functions,
    };
  },
  methods: {
    isEndorsement(item) {
      return !!item.endorsementId;
    },
    getDetailsUrl(item) {
      return this.isEndorsement(item)
        ? `auto/apolice/${item.id_proposta}/endosso`
        : `/auto/proposta/${item.id_proposta}`;
    },
    async copiarLink(chave) {
      await navigator.clipboard.writeText(
        `${process.env.VUE_APP_URL_VISTORIA}/${chave}`,
      );
      this.$vs.notify({
        position: 'top-center',
        title: 'Sucesso',
        text: 'Link copiado com sucesso.',
        color: 'success',
      });
    },
    permitirReabrirVistoria(item) {
      const maxInspectionReopeningsConfig =
        process.env.VUE_APP_MAX_REOPENING_INSPECTION;

      const canReopenInFirstSubmission =
        item.number_first_submission_reopenings < maxInspectionReopeningsConfig;

      const canReopenInPending =
        item.number_pending_reopenings < maxInspectionReopeningsConfig;
      const hasBeenRefused = item.qtdRecusa > 0;

      return hasBeenRefused ? canReopenInPending : canReopenInFirstSubmission;
    },
    async reabrirVistoria(item) {
      if (!this.permitirReabrirVistoria(item)) {
        return;
      }
      const controller = 'prior-inspections';
      const action = `${item.inspection_id}/manual-reopen-inspection`;
      try {
        this.$vs.loading();
        await lifeService.update(controller, null, action);
        notify.notifySuccess(this.$vs, 'Vistoria disponivel por mais 24h.');
        this.$emit('updateData');
      } catch (error) {
        notify.notifyFail(this.$vs, error.response.data.message);
      } finally {
        this.$vs.loading.close();
      }
    },
    getTooltipText(item) {
      if (!this.permitirReabrirVistoria(item)) {
        return 'Não há mais reaberturas disponíveis';
      }
      return 'Reabrir vistoria';
    },
  },
};
</script>

<style scoped>
.vx-row {
  border-bottom: 1px solid #ddd;
}

.vx-col {
  box-sizing: border-box;
  padding: 8px;
}

.icon-copy-large {
  font-size: 28px;
}

.disabled-button {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
<style lang="scss">
.tooltip {
  z-index: 99999;
}
</style>
